import React, { useRef, useState, useEffect } from 'react'
import { Imprimir, Filtro, BtnAcao } from './Acoes'
import ReactToPrint from 'react-to-print'
import { meses } from '../util/Utilitarios'
import { withRouter, Link } from 'react-router-dom'
import '../assets/css/relatorio.css'
import { getUsuario } from '../util/Configuracoes'
import { BotaoPadrao } from './Botoes'
import { ModalCadastro } from './Modais'
import { ordenar, ordenarMultiplo } from './Ordenamentos'
import { InputSwitchSemFormik } from './Inputs'
import { LoadRelatorio } from './Loading'
import moment from 'moment'
import axios from 'axios'
import { mostrarToast } from './Toasts'
import { isMobile } from "react-device-detect";
// COMO USAR

// titulo = titulo do relatorio
// filtros = {
//         filtro: 'nome para exibir',
//         dado: 'dado da filtragem'
//     },
//  dados = [{
//      agrupamento: 'nome para exibir',
//      numerarLinha: true or false. Default false
//      colunas: [{
//          label: 'nome para exibir',
//          name: 'coluna correspondente em data',
//          totalizar: true or false,
//          alinhamento: 'text-center || text-right',
//          visivel: true or false,
//          ordenamento: {
//              tipo: 'tipo do metodo de ordenamento',
//              ativo: true or false, define se virá ordenado ou não
//              modo: 'desc' or 'asc'
//          }
//      }]
//  }]
// showModalFiltros,
// setShowModalFiltros
// campos de filtros dentro do componente

const ConsultaRelatorio = (props) => {
    const ref = useRef(null)
    const user = getUsuario();
    const reference = useRef();
    const btnPrint = useRef();
    const actualDate = new Date();
    const [arrayConfigCol, setArrayConfigCol] = useState([])
    const [arrayOrdenamento, setArrayOrdenamento] = useState([])
    const [showModalColunas, setShowModalColunas] = useState(false)
    const [loadingPrint, setLoadingPrint] = useState(false)

    const [arrayFiltro, setArrayFiltro] = useState([])

    useEffect(() => {
        const dadosNum = props.dados.filter(item => item.numerarLinha)
        if (dadosNum.length > 0) {
            props.dados.map((item, idxAg) => {
                if (item.numerarLinha && props.dados[idxAg].colunas && !props.dados[idxAg].colunas.find(x => x.name === '#'))
                    props.dados[idxAg].colunas.unshift({ label: '#', name: '#', alinhamento: 'text-center', visivel: true, width: '50px' })
            })
        }

        if (dadosNum.length > 0) {
            props.dados.map((item, idxAg) => {
                if (idxAg)
                    props.dados[idxAg].colunas.shift({ label: '#', name: '#', alinhamento: 'text-center', visivel: true, width: '50px' })
            })
        }

        let preArrayOrdenamento = props.dados.length ? Array(props.dados.length).fill({}) : []
        preArrayOrdenamento = props.dados.map((ag, idxAg) => {
            let contador = 0;
            return ag.colunas ? ag.colunas.map(item => {
                if (item.ordenamento && item.ordenamento.ativo)
                    contador++
                return {
                    coluna: item.name,
                    ordenamento: item.ordenamento && item.ordenamento.ativo ? {
                        modo: item.ordenamento.modo || 'asc',
                        tipo: item.ordenamento.tipo || 'texto',
                        ativo: true,
                        ordem: contador
                    } : {
                        modo: 'asc',
                        tipo: item.ordenamento ? item.ordenamento.tipo || 'texto' : 'texto',
                        ativo: false
                    },
                    visivel: item.visivel ? true : false
                }
            }) : []
        })
        const mapOrdenamentos = arrayConfigCol.filter(itemOrd => preArrayOrdenamento.findIndex(x => x.coluna === itemOrd.coluna) > -1)

        if (arrayConfigCol.length === 0 || (Array.isArray(arrayConfigCol[0]) && arrayConfigCol[0].length === 0) || (preArrayOrdenamento.length !== arrayConfigCol.length && mapOrdenamentos.length !== arrayConfigCol.length) || props.dados[0].colunas.length !== arrayConfigCol.length) {
            setArrayOrdenamento(preArrayOrdenamento.map(item => item.map(coluna => coluna.ordenamento.ordem ? true : false)))
            setArrayConfigCol(preArrayOrdenamento)
        }
        else {
            setArrayOrdenamento(arrayOrdenamento)
            setArrayConfigCol(arrayConfigCol)
        }

    }, [props.dados])

    useEffect(() => {

        if (props.filtros && props.filtros.length > 0)
            setArrayFiltro(props.filtros)

    }, [props.filtros])

    const setOrdenamento = (idxColuna, data, idxOrdenamento) => {
        const cloneRelatorioAtual = { ...props.relatorioAtual }
        let ultima = 0;
        const cloneArrayConfigCol = arrayConfigCol[idxOrdenamento]
        for (let i = 0; i < cloneArrayConfigCol.length; i++) {
            if (cloneArrayConfigCol[i].ordenamento.ordem && cloneArrayConfigCol[i].ordenamento.ordem > ultima)
                ultima = cloneArrayConfigCol[i].ordenamento.ordem
        }

        let cloneArray = [...arrayConfigCol]
        let cloneIniciarOrdenamento = [...arrayOrdenamento]
        if (cloneArray.length > 0) {
            let objOrdenamento = { ...cloneArray[idxOrdenamento][idxColuna] }

            if (!objOrdenamento.ordenamento.ativo) {
                objOrdenamento.ordenamento.ativo = true
                objOrdenamento.ordenamento.ordem = ultima + 1
            } else
                objOrdenamento.ordenamento.modo = objOrdenamento.ordenamento.modo === 'asc' ? 'desc' : 'asc'

            cloneArray[idxOrdenamento].splice(idxColuna, 1, objOrdenamento)
            cloneIniciarOrdenamento[idxOrdenamento].splice(idxColuna, 1, true)

            setArrayOrdenamento(cloneIniciarOrdenamento)
            setArrayConfigCol(cloneArray)

            cloneRelatorioAtual.colunas.map(x => x.ordenamento = cloneArray[idxOrdenamento].find(y => y.coluna === x.name).ordenamento)

            props.setRelatorioAtual(cloneRelatorioAtual)
        }
    }

    const mudarVisibilidadeColuna = (idxAgrupamento, idxColuna, valor) => {
        let cloneArray = [...arrayConfigCol]
        let cloneAgrupamento = [...arrayConfigCol[idxAgrupamento]]
        let cloneColuna = { ...cloneAgrupamento[idxColuna] }
        const cloneRelatorioAtual = { ...props.relatorioAtual }

        cloneColuna.visivel = valor !== undefined ? valor : !cloneColuna.visivel
        cloneAgrupamento.splice(idxColuna, 1, cloneColuna)
        cloneArray.splice(idxAgrupamento, 1, cloneAgrupamento)
        setArrayConfigCol(cloneArray)

        cloneRelatorioAtual.colunas.map(x => x.visivel = cloneArray[idxAgrupamento].find(y => y.coluna === x.name).visivel)

        props.setRelatorioAtual(cloneRelatorioAtual)
    }

    const mudarVisibilidadeColunaUnico = (idxColuna, valor) => {
        let cloneArray = [...arrayConfigCol]
        cloneArray = cloneArray.map((x, idx) => {
            x[idxColuna].visivel = valor;
            return x
        });
        setArrayConfigCol(cloneArray)
    }

    const colunasSaoIguais = (props) => {
        return props.visibilidadeColunasNaoAgrupado === undefined ? false : props.visibilidadeColunasNaoAgrupado
    }

    const obterChecksColunasIguais = (props) => {
        let x = props.dados[0];
        return (<>
            {
                x.colunas && x.colunas.map((y, idy) => {
                    return <div className="row-space-between ptb-15 plr-20 bb-1" >
                        <div>
                            <span className="titulo-acao">{y.label}</span>
                        </div>
                        <InputSwitchSemFormik
                            tamanho="-"
                            size="md"
                            checked={arrayConfigCol[0][idy] && arrayConfigCol[0][idy].visivel}
                            onClick={() => {
                                mudarVisibilidadeColunaUnico(idy, (!arrayConfigCol[0][idy].visivel));
                            }} />
                    </div>
                })
            }
        </>)
    }

    const obterChecksMudarVisibilidade = (props) => {

        if (colunasSaoIguais(props)) {
            return obterChecksColunasIguais(props)
        }

        return (<> {
            props.dados.map((x, idx) =>
                <>
                    {x.agrupamento && <h6 className="mt-2"><b>{x.agrupamento}</b></h6>}

                    {/* COLUNAS */}
                    {x.colunas && x.colunas.map((y, idy) => {
                        return <div className="row-space-between ptb-15 plr-20 bb-1" >
                            <div>
                                <span className="titulo-acao">{y.label}</span>
                            </div>
                            <InputSwitchSemFormik
                                tamanho="-"
                                size="md"
                                checked={arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel}
                                onClick={() => mudarVisibilidadeColuna(idx, idy)} />
                        </div>
                    })}</>
            )
        }</>)
    }

    const obterDataOrdenado = (idx, data) => {
        if (arrayOrdenamento[idx] && arrayOrdenamento[idx].filter(item => item === true).length > 0) {
            let ordenamentos = arrayConfigCol[idx].filter((item, idi) => arrayOrdenamento[idx][idi]).sort((a, b) => { return a.ordenamento.ordem - b.ordenamento.ordem })
            return ordenarMultiplo(data, ordenamentos)
        }
        return data
    }

    const limparOrdenamentos = (idx) => {
        const cloneRelatorioAtual = { ...props.relatorioAtual }
        let cloneArray = []
        cloneArray = Array(arrayOrdenamento[idx].length).fill(false)
        let cloneArrayConfig = arrayConfigCol[idx]
        cloneArrayConfig = cloneArrayConfig.map(item => {
            item.ordenamento.ativo = false
            item.ordenamento.modo = 'asc'
            delete item.ordenamento.ordem
            return item
        })

        arrayOrdenamento.splice(idx, 1, cloneArray)
        arrayConfigCol.splice(idx, 1, cloneArrayConfig)
        setArrayOrdenamento(arrayOrdenamento)
        setArrayConfigCol(arrayConfigCol)
        cloneRelatorioAtual.colunas.map(x => x.ordenamento = cloneArrayConfig.find(y => y.coluna === x.name).ordenamento)
        props.setRelatorioAtual(cloneRelatorioAtual)
    }

    const agrupamento = (arr, fields, colunas, position) => {
        //[{coluna:'municipio_codigo_ibge', descricao:'municipio_naturalidade'}]
        let field = fields[0]               // um agrupamento por vez
        if (!field) {
            return arr
        }
        let retArr = Object.values(
            arr.reduce((obj, current) => {
                if (!obj[current[field.coluna]]) obj[current[field.coluna]] = { agrupado: true, descricao: current[field.descricao], dados: [] }
                obj[current[field.coluna]].dados.push(current)
                return obj
            }, {}))

        // recursivo se ainda houver agrupamentos
        if (fields.length) {
            retArr.forEach(obj => {
                obj.count = obj.dados.length
                obj.position = position || 0
                obj.dados = agrupamento(obj.dados, fields.slice(1), colunas, (position || 0) + 1)
            })
        }
        return retArr
    }

    const retornoAgrupamento = (array, agrupamentos, colunas, carregandoDados) => {
        if (!array) return;
        const retorno = agrupamento(array, agrupamentos, colunas);
        return retorno;
    }

    const htmlAgrupado = (arrayAgrupado, colunas, arrayHtml, itensUsados) => {
        if (arrayAgrupado && arrayAgrupado.length) {
            if (arrayAgrupado[0].agrupado) {
                arrayAgrupado.map((item, idx) => {
                    if (item.agrupado)
                        arrayHtml.push(<tr className={item.position === 1 ? 'titulo-2' : 'titulo-1'}><td colspan={`${colunas ? colunas.length : 0}`}
                            className={'agrupamento bold mb-1 mt-3 ' + (item.position === 1 ? ' pt-1 pl-2 mt-1 pb-1' : ' pt-2 pb-2')}>{item.descricao}</td></tr>)
                    return htmlAgrupado(item.dados, colunas, arrayHtml, itensUsados)
                })
            } else {
                const array = obterDataOrdenado(0, arrayAgrupado);

                arrayHtml.push(arrayOrdenamento ? array.map((linha, idxLinha, self) => {
                    return <tr className={'tr-data'}>
                        {colunas && colunas.map((coluna, idy) => {
                            if (coluna.name === '#')
                                return (arrayConfigCol[0][idy] && arrayConfigCol[0][idy].visivel) && <td className={`td-data text-center`}>{idxLinha + 1}</td>

                            return (arrayConfigCol[0][idy] && arrayConfigCol[0][idy].visivel) ? <td className={`td-data ${coluna.alinhamento && coluna.alinhamento || ''}`}>{
                                linha[coluna.name]
                            }</td> : <></>
                        })}
                    </tr>
                }
                ) : <></>)
            }
        }
    }

    const tipoRelatorioDefault = _ => <>
        {
            props.agrupamento ?
                props.dados.map((x, idx) => {

                    let carregandoDados = false;
                    //passando duas vezes no map ^^
                    let htmlAgrupamento = [];
                    let jaUsados = [];
                    let dadosAgrupados = retornoAgrupamento(x.data, props.agrupamento, x.colunas, carregandoDados);
                    htmlAgrupado(dadosAgrupados, x.colunas, htmlAgrupamento, jaUsados)

                    return <table className="table-agrupamento">
                        {/* Remover Ordenamentos */}
                        {(arrayOrdenamento[idx] && arrayOrdenamento[idx].filter(item => item === true).length > 0) && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                            className={'bold'}><Link to='#' className='d-none-print' onClick={() => limparOrdenamentos(idx)}>Remover ordenamentos</Link></td></tr>}

                        {/* COLUNAS */}
                        <thead style={{ 'display': 'table-header-group' }}>
                            <tr className="group-title">
                                {/* {x.numerarLinha && <td onClick={(event) => {}} className={`bold coluna text-center`}>#</td>} */}

                                {x.colunas && x.colunas.map((y, idy) => {
                                    let classes = (y.ordenamento ? 'ordenavel ' : '') + (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].ordenamento.ativo && arrayConfigCol[idx][idy].coluna === y.name ? 'ordenamento_' + arrayConfigCol[idx][idy].ordenamento.modo : '');
                                    return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td onClick={(event) => {
                                        if (y.ordenamento)
                                            setOrdenamento(idy, x.data, idx)
                                    }} style={{ width: y.width || 'auto' }} className={`bold coluna ${y.alinhamento && y.alinhamento || ''} ${classes}`}>{y.label}</td>
                                })}
                            </tr>
                        </thead>

                        <tr> <td colspan={x.colunas ? x.colunas.length : 0}></td> </tr>

                        {htmlAgrupamento}
                    </table>
                })
                : props.dados.map((x, idx) => {
                    // if(x.numerarLinha) {
                    //     x.colunas = [{label: '#', name: '#', alinhamento: 'text-center'}, ...x.colunas]
                    // } 

                    return (
                        <table>
                            {/* AGRUPAMENTO */}
                            {x.agrupamento && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                                className={'agrupamento bold'}>{x.agrupamento}</td></tr>}

                            {/* Remover Ordenamentos */}
                            {(arrayOrdenamento[idx] && arrayOrdenamento[idx].filter(item => item === true).length > 0) && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                                className={'bold'}><Link to='#' className='d-none-print' onClick={() => limparOrdenamentos(idx)}>Remover ordenamentos</Link></td></tr>}

                            {/* COLUNAS */}
                            <tr className="group-title">
                                {/* {x.numerarLinha && <td onClick={(event) => {}} className={`bold coluna text-center`}>#</td>} */}

                                {x.colunas && x.colunas.map((y, idy) => {
                                    let classes = (y.ordenamento ? 'ordenavel ' : '') + (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].ordenamento.ativo && arrayConfigCol[idx][idy].coluna === y.name ? 'ordenamento_' + arrayConfigCol[idx][idy].ordenamento.modo : '');
                                    return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td onClick={(event) => {
                                        if (y.ordenamento)
                                            setOrdenamento(idy, x.data, idx)
                                    }} style={{ width: y.width || 'auto' }} className={`bold coluna ${y.alinhamento && y.alinhamento || ''} ${classes}`}>{y.label}</td>
                                })}
                            </tr>

                            {/* DADOS */}
                            {x.data ? (arrayOrdenamento ? obterDataOrdenado(idx, x.data).map((linha, idxLinha) =>
                                <tr className={`tr-data 1 ${x.classeTr || ''}`}>
                                    {x.colunas && x.colunas.map((coluna, idy) => {
                                        if (coluna.name === '#') {
                                            return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td className={`td-data text-center`}>{idxLinha + 1}</td>
                                        }

                                        return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) ? <td className={`td-data ${coluna.alinhamento && coluna.alinhamento || ''}`}>{
                                            linha[coluna.name]
                                        }</td> : <></>
                                    })}
                                </tr>
                            ) : <></>) : <></>}

                            {/* TOTAIS AGRUPAMENTO */}

                            {x.colunas && x.colunas.filter((z, idz) => z.totalizar && arrayConfigCol[idx][idz] && arrayConfigCol[idx][idz].visivel).length &&
                                <tr className={'tr-data'}>
                                    {x.colunas.find(x => x.name === '#').visivel && <td className={`td-total td-data bold`}>Totais:</td>}
                                    {
                                        x.colunas.map((z, index) => {
                                            if (!(z.name === '#' && z.visivel)) {
                                                if (z.totalizar) {
                                                    let total = 0.0
                                                    x.data.map(linha => total += parseFloat(linha[z.name]))

                                                    return (<td className={`td-total td-data bold ${z.alinhamento && z.alinhamento || ''}`}>{total}</td>)
                                                }
                                                else if (z.visivel)
                                                    return (<td className={`td-total td-data`}></td>)
                                            }
                                        })
                                    }
                                </tr> || <></>
                            }
                        </table>
                    )
                })
        }

        {/* TOTAIS GERAL */}
        {
            props.dados.find((x, idx) => x.colunas && x.colunas.find((y, idy) => y.total_geral && arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel)) &&
            <>
                <tr><td colspan={`${props.dados[0].colunas ? props.dados[0].colunas.filter(x => x.visivel).length : 0}`} className={'bold total-geral'}>Total Geral</td></tr>
                <tr>
                    {
                        props.dados[0].colunas.map((z, index) => {
                            if (z.totalizar) {
                                let total = 0
                                props.dados.map(array => array.data.map(y => {
                                    total += parseFloat(y[z.name])
                                }))

                                return (<td className={`td-total td-total-geral bold td-data ${z.alinhamento && z.alinhamento || ''}`}>{total}</td>)
                            }
                            else
                                return (<td className={'td-total td-total-geral'}></td>)
                        })
                    }
                </tr>
            </>
        }

        <tr><td colspan={`${props.dados[0].colunas ? props.dados[0].colunas.filter(x => x.visivel).length : 0}`} className={'last'}>&nbsp;</td></tr>
    </>

    const switchTipoRelatorio = dados => {
        if (!props.dados[0].relatorioEspecifico)
            return tipoRelatorioDefault()
        else
            return props.dados[0].relatorioEspecifico(dados, arrayConfigCol, { setOrdenamento, arrayOrdenamento, limparOrdenamentos, obterDataOrdenado })
    }

    const cssPageNumber = `
        div.divFooter {
          position: fixed;
          right: 0;
          bottom: 30px;
        }
        div.divFooter::after {
            content: counter(page) !important;
        }`

    return (
        <>
            <ReactToPrint pageStyle={`@page { size: a4 ${props.orientacao || 'auto'} !important; margin-bottom: 10px !important; counter-increment: page;}`} trigger={() => <button className={"hidden d-none"} ref={btnPrint} />} content={() => reference.current} />
            <div className={`impressao card mt-3 ${props.orientacao || 'portrait'}`} ref={reference} >
                <div className="card-body" >
                    <div className={'d-block-print'}>
                        <div className={'col-12 row'}>
                            <div className="col-4">
                                <h5>{props.titulo}</h5>
                                {
                                    props.tituloData ?
                                        <h6>{moment(props.tituloData, 'DD/MM/YYYY').format('DD') + ' de ' + (moment(props.tituloData, 'DD/MM/YYYY').format('MM') || meses.default) + ' de ' + moment(props.tituloData, 'DD/MM/YYYY').format('YYYY')}</h6>
                                        : <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                                }
                            </div>
                            <div className="col-8 text-right">
                                <div className='justify-content-right margin-negativo' >
                                    <img alt='logo' className="logo-menu" src={require('../assets/img/logo-coopanest.png')}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'d-none-print ajusta-titulo'}>
                        <div className={'col-12 row mr-0 ml-0 pl-0 pr-0'}>
                            <div className="col-12 row-space-between p-0">
                                <div>
                                    <BtnAcao icone="icon-Arrow-Left" texto="Voltar" action={() => props.urlVoltar ? window.location.href = props.urlVoltar : props.history ?
                                        (props.history.location && props.history.location.listagem && props.history.location.listagem.goBackAlternativo ? window.history.go(-2) :
                                            (document.referrer.length > 0 ? (!document.referrer.includes(props.history.location.pathname) ? props.history.goBack() : props.history.push('/dashboard')) :
                                                props.history.push('/dashboard'))) :
                                        (document.referrer.length > 0 && document.referrer !== window.location.href ? window.history.back() : window.location.href = '/dashboard')} />
                                </div>
                                <div className="text-right">
                                    {props.filtros ? <BtnAcao icone="icon-Filter-2" texto="Filtros" action={() => props.setShowModalFiltros(!props.showModalFiltros)} /> : <></>}
                                    <BtnAcao icone="icon-Pen" texto="Editar Colunas" action={() => setShowModalColunas(true)} />
                                    <Imprimir loading={loadingPrint} action={(props) => {
                                        setLoadingPrint(true);
                                        var html = document.getElementsByTagName('html')[0].innerHTML;
                                        html = html.replace(document.getElementsByTagName('body')[0].innerHTML, "<body>" + reference.current.innerHTML + "</body>");
                                        html = html.replace("rgb(248, 248, 248) !important;", "white !important;");
                                        var bodyFormData = new FormData();
                                        bodyFormData.append('html', html);
                                        bodyFormData.append('urlBase', "https://sgcplasma.coopanestgo.com.br/");
                                        mostrarToast('print-msg', 'Estamos preparando sua impressão, aguarde alguns segundos até ' + (isMobile ? 'seu PDF seja gerado e seu download seja concluído.' : ' ela seja concluída.'), 4000)
                                        axios.post('https://htmltopdf.selectasistemas.com/convert/htmltopdf', bodyFormData, { "Content-Type": "multipart/form-data" })
                                            .then(response => {
                                                let basePdf = response.data;
                                                let byteCharacters = atob(basePdf);
                                                let byteNumbers = new Array(byteCharacters.length);
                                                for (let i = 0; i < byteCharacters.length; i++) {
                                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                }
                                                let byteArray = new Uint8Array(byteNumbers);
                                                let file = new Blob([byteArray], { type: 'application/pdf;base64' });
                                                let fileURL = URL.createObjectURL(file);
                                                if (!isMobile) {
                                                    window.open(fileURL);
                                                }
                                                else {
                                                    const link = document.createElement('a');
                                                    link.href = fileURL;
                                                    link.setAttribute(
                                                        'download',
                                                        `relatorio.pdf`,
                                                    );

                                                    // Append to html link element page
                                                    document.body.appendChild(link);

                                                    // Start download
                                                    link.click();

                                                    // Clean up and remove the link
                                                    link.parentNode.removeChild(link);
                                                }
                                                setLoadingPrint(false);
                                            }).catch(error => {
                                                setLoadingPrint(false);
                                                mostrarToast('erro', 'Não foi possível gerar sua impressão.')
                                            })
                                    }
                                    } />
                                </div>
                            </div>
                            <div className="col-12 titulo-visualizacao">
                                <h5>{props.titulo}</h5>
                                {
                                    props.tituloData ?
                                        <h6>{moment(props.tituloData, 'DD/MM/YYYY').format('DD') + ' de ' + meses[parseInt(moment(props.tituloData, 'DD/MM/YYYY').format('MM'))] + ' de ' + moment(props.tituloData, 'DD/MM/YYYY').format('YYYY')}</h6>
                                        : <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="dados-relatorio" ref={ref}>
                        {props.esconderFiltros ? <></> :
                            <div className="group-filter">
                                <h6 className={'bold'}><span className={'bold icon-Filter-2'}></span> Filtros Utilizados {props.filtros && props.filtros.length && props.removerFiltros ? <span class="span-button d-none-print" onClick={() => props.removerFiltros()}>Remover Filtros</span> : <></>}
                                </h6>
                                {props.filtros && props.filtros.length &&
                                    props.filtros.map(x =>
                                        <><span><b>{x.filtro}: </b>{x.dado}</span><br /></>
                                    ) ||
                                    <span className={'filter'}>Nenhum filtro selecionado</span>
                                }
                            </div>}
                        {props.loading && <LoadRelatorio refLoading={ref} />}
                        {!props.loading && props.dados && <div className="group-data mb-1">
                            {(props.dados.length && arrayConfigCol.length) && switchTipoRelatorio(props.dados) ||
                                <span>Nenhum dado encontrado!</span>
                            }
                            {props.corpoRelatorio && props.corpoRelatorio}
                        </div>}
                    </div>
                </div>
                <div className="footer-only-print">
                    <div className="col-md-12">
                        <span><i>Relatório emitido por <b>{user.nome}</b> no dia {moment().format('DD/MM/YYYY')} às {moment().format('HH:mm:ss')}</i></span>
                    </div>
                </div>
            </div>
            <ModalCadastro setShowModal={props.setShowModalFiltros} show={props.showModalFiltros} titulo={'Filtros'}>
                {props.children}
            </ModalCadastro>

            <ModalCadastro setShowModal={setShowModalColunas} show={showModalColunas} titulo={'Colunas'}>
                {props.dados && props.dados.length && arrayConfigCol.length ?
                    obterChecksMudarVisibilidade(props)
                    :
                    <></>}
            </ModalCadastro>
        </>
    )
}

export { ConsultaRelatorio }
